import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import RootLayout from "../pages/RootLayout";
import { Detail, Fetch, ImportData, InputPost, InputPut } from "../cpn/page";
import { ImportFile } from "../pages/import/Import";
import { ActivationForm } from "../pages/active/active";
import { UserContainer, Profile } from "../pages/users";
import { UpdateUser } from "../pages/users/Update";
import { CreateUser } from "../pages/users/Create";
import { SiteMap, Map } from "../pages/site";
import { Diagram } from "../pages/diagram";
import { Version } from "../pages/version";
import {
  EventLogs,
  LogsContainer,
  LichSuSoanHangERP,
  LichSuXacNhanGiaoHangERP,
} from "../pages/logs";
import { PermissionDetail, PermissionGroups } from "../pages/permissions";
import { PXK } from "../pages/PXK";
import { AuthLogin, SignOut } from "../pages/auth";
import LogsTagContainer from "../pages/logsTag";
import {
  CreateLenhDongBao,
  GanThongTinSanPham,
  UpdateLenhDongBao,
} from "../pages/LenhDongBao";
import { CreateLenhSanXuat, UpdateLenhSanXuat } from "../pages/LenhSanXuat";
import { CreatePhieuNhapkho, UpdatePhieuNhapkho } from "../pages/PhieuNhapKho";
import { CreateLenhXuatHang, UpdateLenhXuatHang } from "../pages/LenhXuatHang";
import ThongKeKho from "../pages/statistics/Kho";
import ThongKeNhapXuatTon from "../pages/statistics/NhapXuatTon";
import Notfound from "../Components/Notfound";
import { ProtectedRoute, PublicOnlyRoute } from "../Hooks/protectedRoute";
import ThongKeSanPham from "../pages/statistics/SanPham";
import CreatePhieuXuatKho from "../pages/PXK/components/create";
import { SyncContainer } from "../pages/Sync";
import SoanHangPhieuXuatKho from "../pages/PXK/components/SoanHangPhieuXuatKho";
import ThongKeKhoByName from "../pages/statistics/Kho/components/KhoByName";
import ThongKeNhapKho from "../pages/statistics/NhapKho";
import ThongKeDongBao from "../pages/statistics/DongBao";
import ThongKeSling from "../pages/statistics/Sling";
import ThongKeBangTai from "../pages/statistics/BangTai";
import { PXKCC } from "../pages/PXKCC";
import { ShipConfirm } from "../pages/ShipConfirm";
import CheckContainer from "../pages/check/CheckContainer";

export default function AppRouter({ pages, auth, url, page }) {
  return createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path="login"
          element={
            <PublicOnlyRoute children={pages?.[0]?.page_id}>
              <AuthLogin isHome={pages?.[0]?.page_id} />
            </PublicOnlyRoute>
          }
        />
        <Route path="signout" element={<SignOut />} />
        {/* <Route path="/not-found" element={<PageNotFound />} /> */}
        <Route path="/logs/:epc" element={<LogsContainer />} />
        <Route path="/check/:epc" element={<CheckContainer />} />
        <Route path="/logsTag/:tagSling" element={<LogsTagContainer />} />
        <Route path="/logs" element={<Notfound />} />
        <Route path="/check" element={<Notfound />} />
        <Route path="/logsTag" element={<Notfound />} />

        <Route
          element={
            <ProtectedRoute
              url={url}
              page={page}
              isHome={pages?.[0]?.page_id}
            />
          }
        >
          <Route path="/" element={<RootLayout page={page} />}>
            <Route
              path=""
              element={
                <ImportFile />
                // <PageNotFound />
              }
            />
            <Route path="history" element={<EventLogs />} />
            <Route path="version" element={<Version />} />
            {/* <Route path="not-found" element={<PageNotFound />} /> */}
            <Route path="map" element={<Map />} />
            <Route path="diagram_db" element={<Diagram />} />
            {/* <Route path="LDB/create" element={<LichDongBao />} /> */}
            <Route path="sitemap" element={<SiteMap />} />
            <Route path="active" element={<ActivationForm />} />
            {/* <Route path={pages?.[0]?.page_id} element={<Fetch />} /> */}
            <Route path=":url/*" element={<Fetch />} />
            <Route path=":url/import/:id" element={<ImportData />} />
            <Route path=":url/add/:id_str" element={<InputPost />} />
            <Route path=":url/update/:id_str/*" element={<InputPut />} />
            <Route path=":url/detail/:id_str/*" element={<Detail />} />
            <Route path="user/profile" element={<Profile />} />

            <Route path="users">
              <Route
                path=""
                element={
                  // auth?.role &&
                  // (["pm", "uad"].includes(auth?.role) ||
                  // auth?.ct?.some(
                  //   ({ table_alias, read }) =>
                  //     table_alias === "accounts" && read
                  // ) ? (
                  <UserContainer />
                  // ) : (
                  //   <PageNotFound />
                  // ))
                }
              />
              <Route path="creating" element={<CreateUser />} />
              <Route path="updating/:username" element={<UpdateUser />} />
            </Route>

            <Route path="privileges">
              <Route
                path="groups"
                element={
                  // auth?.role &&
                  // (["pm", "uad"].includes(auth?.role) ||
                  // auth?.ct?.some(
                  //   ({ table_alias, read }) =>
                  //     table_alias === "privilegegroup" && read
                  // ) ? (
                  <PermissionGroups />
                  // ) : (
                  //   <PageNotFound />
                  // ))
                }
              />
              <Route path="groups/:id" element={<PermissionDetail />} />
            </Route>

            {/* custom pages */}
            <Route
              path="PhieuXuatKho/create"
              element={<CreatePhieuXuatKho />}
            />
            <Route path="PhieuXuatKho/:id" element={<PXK />} />
            <Route path="PhieuXuatKhoChuyenChu/:id" element={<PXKCC />} />
            <Route path="LenhDongBao/create" element={<CreateLenhDongBao />} />
            <Route
              path="LenhDongBao/update/:id"
              element={<UpdateLenhDongBao />}
            />
            <Route path="LenhSanXuat/create" element={<CreateLenhSanXuat />} />
            <Route
              path="LenhSanXuat/update/:id"
              element={<UpdateLenhSanXuat />}
            />
            <Route
              path="PhieuNhapKho/create"
              element={<CreatePhieuNhapkho />}
            />
            <Route
              path="PhieuNhapKho/update/:id"
              element={<UpdatePhieuNhapkho />}
            />
            <Route
              path="LenhXuatHang/create"
              element={<CreateLenhXuatHang />}
            />
            <Route
              path="LenhXuatHang/update/:id"
              element={<UpdateLenhXuatHang />}
            />
            <Route path="ThongKe/Kho" element={<ThongKeKhoByName />} />
            <Route path="ThongKe/NhapKho" element={<ThongKeNhapKho />} />
            <Route path="ThongKe/DongBao" element={<ThongKeDongBao />} />
            <Route path="ThongKe/Sling" element={<ThongKeSling />} />
            <Route path="ThongKe/BangTai" element={<ThongKeBangTai />} />

            <Route
              path="ThongKe/NhapXuatTon"
              element={<ThongKeNhapXuatTon />}
            />
            <Route path="ThongKe/SanPham" element={<ThongKeSanPham />} />
            <Route path="LichSuSoanHangERP" element={<LichSuSoanHangERP />} />
            <Route
              path="LichSuXacNhanGiaoHangERP"
              element={<LichSuXacNhanGiaoHangERP />}
            />
            <Route path="ShipConfirm" element={<ShipConfirm />} />
            <Route path="GanThongTinSanPham" element={<GanThongTinSanPham />} />
            <Route
              path="SoanHangPhieuXuatkho"
              element={<SoanHangPhieuXuatKho />}
            />
            <Route path="SyncData" element={<SyncContainer />} />
          </Route>
        </Route>
      </>
    )
  );
}
